/**
 * Created by Alican Köker on 2019-04-01.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {Timeline, TimelineLite} from "gsap";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";

export class EdisonIndividualWPController extends BetWayWinIndividualWPController {

    private _betLineDelay:number = 2.4;

    constructor(config:IIndividualWinPresentationConfig) {
        super(config, "IndividualWin", true);
    }

    protected getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        const timeline:TimelineLite = betWayWinData ? <TimelineLite>super.getLineAnimation(betWayWinData) : new TimelineLite();
        timeline.add(() => {}, `+=${this._betLineDelay}`);

        return timeline;
    }


    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {

        const initialWinDelay:number = 1;

        if(this._gameData!.nextMode !== EdisonGameMode.FREESPIN) {
            EdisonGameModuleConfig.winPresentationView.resetAnimations();
            timeline.add(() => EdisonGameModuleConfig.individualWPView.playSPAnim(reelId, symbolId), startTime + reelId * .35 + initialWinDelay);
            timeline.add(() => {
                EdisonGameModuleConfig.winWaysSign.showWaysWon(betWayWinData.numberOfCombinations, betWayWinData.symbol + initialWinDelay);
            });/*
            if(reelId === 4)
                timeline.add(() => {}, 3.5);*/
        }
    }

    protected stopWinPresentation(isAbort:boolean):void {
        //super.stopWinPresentation(isAbort);
        if(this._gameData!.nextMode !== EdisonGameMode.FREESPIN) {
            if(this._currentLineAnimation) {
                if(this._currentLineAnimation.isActive()) {
                    this._currentLineAnimation.pause();
                    this._currentLineAnimation.kill();
                }
                this._currentLineAnimation = null;
            }
            EdisonGameModuleConfig.individualWPView.hidePresentations();
        }
    }

    protected startWinPresentation():void {
        super.startWinPresentation();
    }
}